import { render, staticRenderFns } from "./GFileAudio.vue?vue&type=template&id=797403b9&"
import script from "./GFileAudio.vue?vue&type=script&lang=js&"
export * from "./GFileAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports